import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { Row, Col, Button, Label } from "reactstrap";
import StoreContext from "./../../../Store/Context";
import moment from "moment";
import {
  PaginationHeader,
  TRIMESTRE_HANDLER,
  validateTokenStorage,
  AREA_LIST,
  NOTE_EDIT,
  NOTA_PROMEDIO_NORMAL,
  NOTA_PROMEDIO_DIVIDO,
  NOTA_PROMEDIO_LITERAL,
  NOTA_VER_TAREA_LITERAL,
  NOTE_EDIT_TAREA_LITERAL
} from "./../../Constants/Util";
import {FILES_EXPLORER,ModalAddComent} from "./../../Constants/Modal";
import { IDataWeek, IGrades,IObjNotas, ISetupC, IAsignatureGrade, IPersonLibreta, IArea, IAsignature_area, IPersonLiteral,IFilesAgenda } from "./../../Constants/Interfaces";
import {
  getSetup,
  getGradesAsigByTeacher,
  getStudentDiaryByGrade,
  getStudentDiaryByGradeKinder,
  getStudentDiaryByGradeLiteral,
  postNota,
  putNota,
  getAreasByGrade,
  postNotaLiteral,
  putNotaLiteral,
  getFileNames,
  createComment
} from "../../Constants/Services";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";
const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;

interface IAgendaTeacherState {
  dataFormSetup: ISetupC;
  dataGrades: IGrades[];
  dataArea: IArea[];
  dataAsignatureArea: IAsignature_area[];
  dataAsignature: IAsignatureGrade[];
  dataPerson: IPersonLibreta[];
  dataPersonLiteral: IPersonLiteral[];
  dataWeek: IDataWeek[];
  formGrade: {
    as_id: string;
    as_desc: string;
    gr_id: string;
    gr_desc: string;
    gr_alias: string;
    ar_literal: string;
    gr_literal:string;
    gr_areas_p:string;
    gr_prom_d:string;
  };
  isOpenGrade: boolean;
  loading: boolean;
  trimestre: string;
  openDetailAgenda: boolean;
  formCurrentAgenda: {
    di_id: string;
    di_date: string;
    di_desc: string;
    ta_desc: string;
    not_score: string;
    per_id:string;
  };
  formComent:{
    not_comment: string,
    not_person: string,
    per_name:string;
    not_agenda: string,
    not_type: string
  }
  objNote: IObjNotas[];
  filesObj:IFilesAgenda[];
  isOpenModalFileExplorer:boolean;
  openModalAddComent:boolean;
  openModalEditComent:boolean;
}
class LibretaTeacher extends Component<RouteComponentProps<{}>, IAgendaTeacherState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      dataAsignatureArea: [],
      dataAsignature: [],
      dataArea: [],
      dataGrades: [],
      objNote:[],
      dataPerson: [],
      dataPersonLiteral: [],
      dataWeek: [],
      dataFormSetup: {
        consejeria:"",
        set_registrationy: "",
        set_aniolectivo: "",
        set_startpactivo: new Date().toString(),
        set_endpactivo: new Date().toString(),
        set_start_ft: new Date().toString(),
        set_end_ft: new Date().toString(),
        set_start_st: new Date().toString(),
        set_end_st: new Date().toString(),
        set_start_tt: new Date().toString(),
        set_end_tt: new Date().toString(),
        set_trimestre: "",
      },
      formGrade: {
        as_id: "",
        as_desc: "",
        gr_id: "",
        gr_desc: "",
        gr_alias: "",
        ar_literal: "",
        gr_literal:"",
        gr_areas_p:"",
        gr_prom_d:""
      },
      formComent:{
        not_comment: "",
        per_name:"",
        not_person: "",
        not_agenda: "",
        not_type: ""
      },
      isOpenGrade: false,
      loading: false,
      trimestre: "I",
      formCurrentAgenda: {
        di_id: "",
        di_date: "",
        di_desc: "",
        ta_desc: "",
        not_score: "",
        per_id:"",
      },
      openDetailAgenda: false,
      filesObj:[],
      isOpenModalFileExplorer:false,
      openModalAddComent:false,
      openModalEditComent:false
    };

    this.fetchGradeAsig = this.fetchGradeAsig.bind(this);
    this.fetchSetup = this.fetchSetup.bind(this);
    this.changeHeader = this.changeHeader.bind(this);
    this.handlerSetGrade = this.handlerSetGrade.bind(this);
    this.fetchStudentDiaryByGrade = this.fetchStudentDiaryByGrade.bind(this);
    this.handlerNota = this.handlerNota.bind(this);
    this.handlerGobackGrade = this.handlerGobackGrade.bind(this);
    this.handlerGobackDetail = this.handlerGobackDetail.bind(this);
    this.onChangeNota = this.onChangeNota.bind(this);
    this.handlerPostNote = this.handlerPostNote.bind(this);
    this.handlerCancelNota = this.handlerCancelNota.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
    this.handlerPutNote = this.handlerPutNote.bind(this);
    this.fetchArea = this.fetchArea.bind(this);
    this.handlerSetCalification = this.handlerSetCalification.bind(this);
    this.handlerPostNoteLiteral = this.handlerPostNoteLiteral.bind(this);
    this.handlerPutNoteLiteral = this.handlerPutNoteLiteral.bind(this);
    this.fecthFileNames = this.fecthFileNames.bind(this);
    this.handleModalPDf = this.handleModalPDf.bind(this);
    this.openModalAddComent = this.openModalAddComent.bind(this);
    this.onChangeComent = this.onChangeComent.bind(this);
    this.saveComment = this.saveComment.bind(this);
  }

  async fecthFileNames({per_id, di_id}) {
    var response;
      response = await getFileNames({
        per_id,
        di_id
      }
      );
    
    this.setState({
      filesObj: response,
      loading: false,
      isOpenModalFileExplorer:true
    });
  }

  async fetchArea(gr_id) {
    const response = await getAreasByGrade(gr_id);
    this.setState({
      dataArea: response.ar,
      dataAsignatureArea: response.asig,
    });
  }

  rechargeData() {
    this.setState({ loading: true });
    const props = this.state.formGrade;
    setTimeout(() => {
      this.fetchStudentDiaryByGrade(props.gr_id, props.as_id, props.ar_literal,props.gr_literal);
    }, 1000);
  }

  handlerPostNoteLiteral({ not_topico, not_person, not_literal }) {
    const props = this.state;
    const body = {
      not_literal,
      not_person,
      not_date: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      not_trimestre: props.dataFormSetup.set_trimestre,
      not_topico,
    };
    postNotaLiteral(body);
    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchStudentDiaryByGrade(props.formGrade.gr_id, props.formGrade.as_id, props.formGrade.ar_literal,props.formGrade.gr_literal);
    }, 1000);
  }

  handlerPutNoteLiteral({ not_id, not_literal }) {
    const props = this.state;
    const body = {
      not_id,
      not_date: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      not_literal,
    };
    putNotaLiteral(body);
    this.setState({ loading: true, openDetailAgenda: false });
    setTimeout(() => {
      this.fetchStudentDiaryByGrade(props.formGrade.gr_id, props.formGrade.as_id, props.formGrade.ar_literal,props.formGrade.gr_literal);
    }, 1000);
  }

  handlerPostNote({ not_agenda, not_person }) {
    const props = this.state;
    const body = {
      not_agenda,
      not_person,
      not_date: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      not_trimestre: props.dataFormSetup.set_trimestre,
      not_score: props.formCurrentAgenda.not_score,
    };
    postNota(body);
    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchStudentDiaryByGrade(props.formGrade.gr_id, props.formGrade.as_id, props.formGrade.ar_literal,props.formGrade.gr_literal);
    }, 1000);
  }

  handlerPutNote({ not_id }) {
    const props = this.state;
    const body = {
      not_id,
      not_date: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      not_score: props.formCurrentAgenda.not_score,
    };
    putNota(body);
    this.setState({ loading: true, openDetailAgenda: true });
    setTimeout(() => {
      this.fetchStudentDiaryByGrade(props.formGrade.gr_id, props.formGrade.as_id, props.formGrade.ar_literal,props.formGrade.gr_literal);
    }, 1000);
  }

  handlerCancelNota(e) {
    this.setState({
      formCurrentAgenda: {
        di_id: "",
        di_date: "",
        di_desc: "",
        ta_desc: "",
        not_score: "",
        per_id:""
      },
      openDetailAgenda: false,
    });
  }

  async fetchSetup() {
    const response = await getSetup();
    this.setState({
      dataFormSetup: response,
      trimestre: response.set_trimestre,
      loading: false,
    });
  }

  async fetchStudentDiaryByGrade(gr_id: string, as_id: string, ar_literal: string, gr_literal:string) {
    const props = this.state;
    var dataStartTrimestre;
    var dataEndTrimestre;

    if (props.trimestre === "I") {
      dataStartTrimestre = props.dataFormSetup.set_start_ft;
      dataEndTrimestre = props.dataFormSetup.set_end_ft;
    } else if (props.trimestre === "II") {
      dataStartTrimestre = props.dataFormSetup.set_start_st;
      dataEndTrimestre = props.dataFormSetup.set_end_st;
    } else if (props.trimestre === "III") {
      dataStartTrimestre = props.dataFormSetup.set_start_tt;
      dataEndTrimestre = props.dataFormSetup.set_end_tt;
    }
    if (ar_literal === "1") {
      const response = await getStudentDiaryByGradeLiteral({
        gr_id: gr_id,
        date_week_start: moment(dataStartTrimestre).format("YYYY-MM-DD"),
        date_week_end: moment(dataEndTrimestre).format("YYYY-MM-DD"),
        trimestre:props.trimestre
      });
      this.setState({
        dataPersonLiteral: response,
        loading: false,
      });
    } else {
      if(gr_literal==="1"){
        const response = await getStudentDiaryByGradeKinder({
          gr_id: gr_id,
          as_id: as_id,
          date_week_start: moment(dataStartTrimestre).format("YYYY-MM-DD"),
          date_week_end: moment(dataEndTrimestre).format("YYYY-MM-DD"),
          trimestre:props.trimestre
        });
        this.setState({
          dataPerson: response,
          loading: false,
        });
      }
      else{
        const response = await getStudentDiaryByGrade({
          gr_id: gr_id,
          as_id: as_id,
          date_week_start: moment(dataStartTrimestre).format("YYYY-MM-DD"),
          date_week_end: moment(dataEndTrimestre).format("YYYY-MM-DD"),
          trimestre:props.trimestre
        });
        this.setState({
          dataPerson: response,
          loading: false,
        });
      }
    }
  }

  async fetchGradeAsig() {
    const response = await getGradesAsigByTeacher(this.context.per_id);
    var asignat = [];
    var hashAsig = {};
    asignat = response.filter((o) => (hashAsig[o.as_id+o.gr_id] || o.as_id === null ? false : (hashAsig[o.as_id+o.gr_id] = true)));
    asignat.sort(function (a, b){
      return (a.gr_id - b.gr_id)
    })
    this.setState({
      dataAsignature: asignat,
    });
  }

  componentDidMount() {
    if (validateTokenStorage()) {
      this.context.quitToken();
    }
    this.fetchSetup();
    this.fetchGradeAsig();
  }

  handlerGobackGrade() {
    this.setState((prevState) => ({
      isOpenGrade: !prevState.isOpenGrade,
      formCurrentAgenda: {
        di_id: "",
        di_date: "",
        di_desc: "",
        ta_desc: "",
        not_score: "",
        per_id:""
      },
      formGrade: {
        as_id: "",
        as_desc: "",
        gr_id: "",
        gr_desc: "",
        gr_alias: "",
        ar_literal: "",
        gr_areas_p:"",
        gr_prom_d:"",
        gr_literal:""
      },
      dataArea:[],
      dataAsignatureArea:[],
      dataPerson:[]
    }));
  }
  
  openModalAddComent({di_id,per_id,per_name,type,not_comment}) {
    this.setState((prevState) => ({
      openModalAddComent: !prevState.openModalAddComent,
      formComent: {
        not_comment,
        per_name,
        not_person: per_id,
        not_agenda: di_id,
        not_type: type
      }
    }));
  }

  handlerGobackDetail() {
    this.setState((prevState) => ({
      openDetailAgenda: !prevState.openDetailAgenda,
      formCurrentAgenda: {
        di_id: "",
        di_date: "",
        di_desc: "",
        ta_desc: "",
        not_score: "",
        per_id:""
      },
      filesObj:[]
    }));
  }

  changeHeader({ trimestre, operation }: any) {
    var current;
    current = TRIMESTRE_HANDLER(trimestre, operation);
    this.setState({
      trimestre: current,
    });
    this.setState({
      trimestre: current,
    });

    setTimeout(() => {
      this.fetchGradeAsig();
    }, 1000);
  }

  handlerSetGrade(gr_id, gr_desc, as_id, as_desc, ar_literal,gr_areas_p,gr_prom_d,gr_literal) {
    this.setState({
      formGrade: {
        as_id,
        as_desc,
        gr_id,
        gr_desc,
        gr_alias: "",
        ar_literal,
        gr_areas_p,
        gr_prom_d,
        gr_literal
      },
      filesObj:[],
      isOpenGrade: true,
      loading: true,
    });
    this.fetchArea(gr_id);
    this.fetchStudentDiaryByGrade(gr_id, as_id, ar_literal,gr_literal);
  }

  handlerNota(di_id, di_date, di_desc, ta_desc) {
    console.log(this.context.per_admin)
    const props = this.state;  
    if(this.context.per_admin ==="1"){
        this.setState({
          formCurrentAgenda: { di_id, di_date, di_desc, ta_desc, not_score: "",per_id:"" },
          openDetailAgenda: true,
          filesObj:[]
        });
    }
    else{
      if (props.trimestre === props.dataFormSetup.set_trimestre) {
        this.setState({
          formCurrentAgenda: { di_id, di_date, di_desc, ta_desc, not_score: "",per_id:"" },
          openDetailAgenda: true,
          filesObj:[]
        });
      }
    }
  }

  validate(s) {
    var rgx = /^[0-9]*\.?[0-9]*$/;
    return s.match(rgx);
  }

  onChangeNota(e: any) {
      this.setState({
        formCurrentAgenda: {
          ...this.state.formCurrentAgenda,
          [e.target.name]: e.target.value,
        },
      });
  }

  handlerSetCalification({ not_literal, not_id, type, not_topico, not_person }) {
    if (type === "put") {
      this.handlerPutNoteLiteral({ not_id, not_literal });
    } else {
      this.handlerPostNoteLiteral({ not_topico, not_person, not_literal });
    }
  }

  handleModalPDf() {

    this.setState((prevState) => ({
      isOpenModalFileExplorer: !prevState.isOpenModalFileExplorer,
      filesObj:[]
    }));

  }
  onChangeComent(e: any) {
    this.setState({
      formComent: {
        ...this.state.formComent,
        [e.target.name]: e.target.value,
      }
    });
  }
  saveComment() {
    const props = this.state.formComent;
    const propsGrade = this.state.formGrade;
    const body = {
      not_agenda:props.not_agenda,
      not_person:props.not_person,
      not_comment:props.not_comment,
    };
    createComment(body);
    this.setState({ loading: true, openModalAddComent: false });
    setTimeout(() => {
      this.fetchStudentDiaryByGrade(propsGrade.gr_id, propsGrade.as_id, propsGrade.ar_literal,propsGrade.gr_literal);
    }, 1000);
  }

  handleKeyPress = (event,not_id) => {
    if(event.key === 'Enter'){
      this.handlerPutNote({not_id})
    }
  }

  handleKeyPress_post = (event,not_person,not_agenda) => {
    if(event.key === 'Enter'){
      this.handlerPostNote({not_agenda,not_person})
    }
  }
  render() {
    const props = this.state;
    var gradeLiteral = [];
    var validarKinder;
     validarKinder = props.dataAsignature.filter(
      (e) =>
        e.gr_literal !== "1"
    );

    var hashGr = {}
    gradeLiteral = props.dataAsignature.filter(o => hashGr[o.gr_id]|| o.gr_id === null ? false : hashGr[o.gr_id] = true);
    var dataAsistant = {};
    var dataWeek = {};
    var dataResult = [];
    var di_idET = 0;
    var di_dateET = 0;
    var di_descET = 0;
    var ta_descET = 0;
    if (props.formGrade.gr_literal === "1" && props.formGrade.ar_literal === "1") {
      dataResult.push({ ar_id: "null" });
      props.dataPersonLiteral.map((data, i) => {
        if (dataAsistant[data.per_id]) {
          dataAsistant[data.per_id].push({
            ar_id: data.ar_id,
            ar_literal: data.ar_literal,
            gr_literal: data.gr_literal,
            not_id: data.not_id,
            not_literal: data.not_literal,
            per_id: data.per_id,
            per_name: data.per_name,
            not_topico: data.not_topico,
          });
        } else {
          dataAsistant = {
            ...dataAsistant,
            [data.per_id]: [
              {
                ar_id: data.ar_id,
                ar_literal: data.ar_literal,
                gr_literal: data.gr_literal,
                not_id: data.not_id,
                not_literal: data.not_literal,
                per_id: data.per_id,
                per_name: data.per_name,
                not_topico: data.not_topico,
              },
            ],
          };
        }
        return null;
      });
    } else {
      dataResult = props.dataPerson.filter((o) => (dataWeek[o.di_date+o.di_id] || o.di_date === null ? false : (dataWeek[o.di_date+o.di_id] = true)));
      props.dataPerson.map((data, i) => {
        if (dataAsistant[data.per_id]) {
          dataAsistant[data.per_id].push({
            di_id: data.di_id,
            di_grade: data.di_grade,
            di_desc: data.di_desc,
            di_date: data.di_date,
            di_asignature: data.di_asignature,
            per_id: data.per_id,
            per_name: data.per_name,
            ta_desc: data.ta_desc,
            ta_id: data.ta_id,
            not_id: data.not_id,
            not_score: data.not_score,
            not_file_name: data.not_file_name,
            not_comment:data.not_comment,
            ar_id: data.ar_id,
            ar_literal: data.ar_literal,
            // gr_literal: data.gr_literal
          });
        } else {
          dataAsistant = {
            ...dataAsistant,
            [data.per_id]: [
              {
                di_id: data.di_id,
                di_grade: data.di_grade,
                di_desc: data.di_desc,
                di_date: data.di_date,
                di_asignature: data.di_asignature,
                per_id: data.per_id,
                per_name: data.per_name,
                ta_desc: data.ta_desc,
                ta_id: data.ta_id,
                not_id: data.not_id,
                not_score: data.not_score,
                not_file_name: data.not_file_name,
                not_comment:data.not_comment,
                ar_id: data.ar_id,
                ar_literal: data.ar_literal,
                // gr_literal: data.gr_literal
              },
            ],
          };
        }
        return null;
      });

      dataResult.map((data, i) => {
        if (data.ta_id === "6") {
          di_idET = data.di_id;
          di_dateET = data.di_date;
          di_descET = data.di_desc;
          ta_descET = data.ta_desc;
        }
        return null;
      });
    }
    var numberArea = 0;
    return (
      <React.Fragment>
        
        {props.openModalAddComent && (
          < ModalAddComent
            title="Agregar comentario"
            isOpen={props.openModalAddComent}
            toggle={this.openModalAddComent}
            onChange={this.onChangeComent}
            toggleSave={this.saveComment}
            dataFomComment={props.formComent}
          />
        )}
          {props.openModalEditComent && (
          < ModalAddComent
            title="Editar comentario"
            isOpen={props.openModalEditComent}
            toggle={this.openModalAddComent}
            onChange={this.onChangeComent}
            toggleSave={this.saveComment}
            dataFomComment={props.formComent}
          />
        )}
         {props.isOpenModalFileExplorer && (
          < FILES_EXPLORER
            title="Ver multimedia"
            isOpen={props.isOpenModalFileExplorer}
            toggle={this.handleModalPDf}
            filesObj={props.filesObj}
          />
        )}
       
        <Row>
          <Col xs={12} className="text-center">
            <h5 className="font-weight-bold">
              Libreta de calificaciones
              <br></br>
              {props.formGrade.gr_id.length > 0 ? (
                <React.Fragment>
                  {props.formGrade.gr_desc} {props.formGrade.gr_alias} {props.formGrade.as_desc}
                </React.Fragment>
              ) : null}
            </h5>
          </Col>
          {props.isOpenGrade ? (
            props.openDetailAgenda ? (
              props.formGrade.gr_literal === "1" && props.formGrade.ar_literal==="0" ?<NOTE_EDIT_TAREA_LITERAL
              dataResult={dataResult}
              dataAsistant={dataAsistant}
              formCurrentAgenda={props.formCurrentAgenda}
              handlerGobackDetail={this.handlerGobackDetail}
              onChangeNota={this.onChangeNota}
              handlerPutNote={this.handlerPutNote}
              handlerPostNote={this.handlerPostNote}
              handlerCancelNota={this.handlerCancelNota}
              openModalAddComent ={this.openModalAddComent}
              getFilesNames ={this.fecthFileNames}
              handleKeyPress = {this.handleKeyPress}
              loading={props.loading}
            /> :<NOTE_EDIT
              dataResult={dataResult}
              dataAsistant={dataAsistant}
              formCurrentAgenda={props.formCurrentAgenda}
              handlerGobackDetail={this.handlerGobackDetail}
              onChangeNota={this.onChangeNota}
              handlerPutNote={this.handlerPutNote}
              handlerPostNote={this.handlerPostNote}
              handlerCancelNota={this.handlerCancelNota}
              openModalAddComent ={this.openModalAddComent}
              getFilesNames ={this.fecthFileNames}
              handleKeyPress = {this.handleKeyPress}
              handleKeyPress_post = {this.handleKeyPress_post}
              loading={props.loading}
            />
              
            ) : (
              <React.Fragment>
                {dataResult.length > 0 ? (
                  <React.Fragment>
                    <Col xs={12} className="text-right mb-4">
                      <ClipLoader css={override} size={23} color={"#36D7B7"} loading={this.state.loading} />
                      <Button className="mr-2 info" onClick={() => this.rechargeData()}>
                        Recargar
                      </Button>
                      <Button className="ok" onClick={() => this.handlerGobackGrade()}>
                        Cerrar
                      </Button>
                    </Col>
                    <Col xs={12} className="text-center table-preescolar table-alert-color-no-height overflow-auto mt-4">
                      <div className="search-table-outte">
                        {props.formGrade.gr_literal === "1" && props.formGrade.ar_literal==="1" ? (
                          <React.Fragment>
                            {props.dataPersonLiteral.length > 0 ? (
                              <NOTA_PROMEDIO_LITERAL
                                dataArea={props.dataArea}
                                dataAsistant={dataAsistant}
                                dataAsignatureArea={props.dataAsignatureArea}
                                handlerSetCalification={this.handlerSetCalification}
                              />
                            ) : (
                              <Label className="font-weight-bold">Sin Resultados</Label>
                            )}
                          </React.Fragment>
                        ) : (
                          props.formGrade.gr_prom_d==="1"?
                          <React.Fragment>
                            <NOTA_PROMEDIO_DIVIDO
                              dataResult={dataResult}
                              dataAsistant={dataAsistant}
                              di_idET={di_idET}
                              di_dateET={di_dateET}
                              di_descET={di_descET}
                              ta_descET={ta_descET}
                              handlerNota={this.handlerNota}
                            />
                          </React.Fragment>:
                          <React.Fragment>
                            {props.formGrade.gr_literal === "1" && props.formGrade.ar_literal==="0" ? (
                          <NOTA_VER_TAREA_LITERAL
                          getFilesNames ={this.fecthFileNames}
                          dataResult={dataResult}
                          dataAsistant={dataAsistant}
                          di_idET={di_idET}
                          di_dateET={di_dateET}
                          di_descET={di_descET}
                          ta_descET={ta_descET}
                          handlerNota={this.handlerNota}
                        />
                            ):                          <NOTA_PROMEDIO_NORMAL
                            dataResult={dataResult}
                            dataAsistant={dataAsistant}
                            di_idET={di_idET}
                            di_dateET={di_dateET}
                            di_descET={di_descET}
                            ta_descET={ta_descET}
                            handlerNota={this.handlerNota}
                          />}
   
                          </React.Fragment>
                        )}
                      </div>
                    </Col>
                    {props.dataArea.length > 0 && props.dataPersonLiteral.length > 0
                      ? props.formGrade.gr_literal === "1" && props.formGrade.ar_literal === "1" && (
                          <AREA_LIST dataArea={props.dataArea} dataAsignature={props.dataAsignatureArea} numberArea={numberArea} />
                        )
                      : null}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Col xs={12} className="text-right mb-4">
                      <Button className="ok" onClick={() => this.handlerGobackGrade()}>
                        Cerrar
                      </Button>
                    </Col>
                    <Col xs={12} className="text-center table-alert-color-no-height">
                      <Label className="font-weight-bold">Sin Resultados</Label>
                    </Col>
                  </React.Fragment>
                )}
              </React.Fragment>
            )
          ) : (
            <React.Fragment>
              <Col xs={12}>
                <PaginationHeader trimestre={props.trimestre} arrow_handler={this.changeHeader} />
              </Col>
              {props.dataAsignature.length > 0 ? (
  
                <React.Fragment>
              {props.dataAsignature.map((data, i) => (
                  <Col xs={6} sm={4} key={i} className="mb-1">
                    <Button
                      className="mt-2 mb-2 w-100 box-h-90px info label-area-desc-bold"
                      onClick={() => this.handlerSetGrade(data.gr_id, data.gr_desc, data.as_id, data.as_desc, "0", data.gr_areas_p,data.gr_prom_d,data.gr_literal)}
                    >
                      {`${data.as_desc.toUpperCase()} -  ${data.gr_desc.toUpperCase()}`}
                    </Button>
                  </Col>
                ))}
                {gradeLiteral.length>0? <React.Fragment> {gradeLiteral.map((lit, i) => 
                {
                  if(validarKinder.length ===0){
                    if(lit.gr_id ==="2"||lit.gr_id ==="3"||lit.gr_id ==="4"){
                      return (
                        <Col xs={6} sm={4} key={i} className="mb-1">
                          <button
                            className="mt-2 mb-2 w-100 box-h-90px warning label-area-desc-bold"
                            onClick={() => this.handlerSetGrade(lit.gr_id, lit.gr_desc, lit.as_id, lit.as_desc, lit.gr_literal, lit.gr_areas_p,lit.gr_prom_d,lit.gr_literal)}
                          >
                            {`CALIFICAR - ${lit.gr_desc.toUpperCase()}`}
                          </button>
                        </Col>
                      )
                    }
                    return null
                  }

                return null
                }) }</React.Fragment>:null
                }
                  </React.Fragment>
              ) : (
                <Col xs={12} className="text-center table-alert-color-no-height">
                  <Label className="font-weight-bold">Sin Resultados</Label>
                </Col>
              )}
            </React.Fragment>
          )}
        </Row>
      </React.Fragment>
    );
  }
}

export default LibretaTeacher;
